import React, { useEffect, useState } from 'react';
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10, TablesWidget5 } from "../../../smallnation/partials/widgets"

import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";

import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { useNavigate, useLocation, useHistory } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UsNumberValidate from "../../modules/utility/usNumberValidate"
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';

const CreateStudent: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [currentYearList, setCurrentYearList] = useState([]);
  const [schoolIds, setSchoolInData] = useState([]);
  const [categories, setCategory] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [additionalCoursesinfo, setAdditionalCourses] = useState('');
  const [skillSetinfo, setSkillsInfo] = useState('');
  //const [coursesInformation, setCoursesInfo] = useState([]);
  const [careerInformation, setCareerInfo] = useState('');
  const [additionalThoughts, setAdditionalThoughts] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  const [itemName, setFieldName] = useState('');
  const [educations, setEducation] = useState([]);
  const [collegeInfo, setCollegeInfo] = useState([]);
  const red = "red";
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function validateCheck() {
    //alert("test");
  }
  const submitValue = () => {

    var categoriesArray = [];
    var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var password_regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    $.each($("input[name='seeking']:checked"), function () {
      categoriesArray.push($(this).val());
    });

    var catofExpertiseArray = [];

    $.each($("input[name='category_m']:checked"), function () {
      catofExpertiseArray.push($(this).val());
    });

    var validateEditorTxt = 1;

    if ($('#first_name').val() == "") {
      $("#firstNameValidMsg").show();
      $(window).scrollTop($('#firstNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#firstNameValidMsg").hide();
    }
    var cls_year = $("#class_year").val();
    if (cls_year == "") {
      $("#class_yearValidMsg").show();
      $(window).scrollTop($('#class_yearValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#class_yearValidMsg").hide();
    }
    //class_yearValidMsg

    if ($('#last_name').val() == "") {
      $("#lastNameValidMsg").show();
      $(window).scrollTop($('#lastNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#lastNameValidMsg").hide();
    }
    var email = $('#email_id').val();
    if (email == "") {
      $("#emailReqMsg").show();
      $(window).scrollTop($('#emailReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailReqMsg").hide();
    }

    if (email != "" && email_regex.test(email) == false) {
      $("#emailValidMsg").show();
      $(window).scrollTop($('#emailValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailValidMsg").hide();
    }

    if ($('#phone_number').val() == "") {
      $("#phoneValidMsg").show();
      $(window).scrollTop($('#phoneValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#phoneValidMsg").hide();
    }

    var password = $('#password').val();
    if (password == "") {
      $("#passwordReqMsg").show();
      $(window).scrollTop($('#passwordReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordReqMsg").hide();
    }

    if (password != "" && password_regex.test(password) == false) {
      $("#passwordValidMsg").show();
      $(window).scrollTop($('#passwordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordValidMsg").hide();
    }

    var passwordConf = $('#passwordConf').val();
    if (passwordConf == "") {
      $("#confpasswordReqMsg").show();
      $(window).scrollTop($('#confpasswordReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswordReqMsg").hide();
    }

    if (passwordConf != "" && password_regex.test(passwordConf) == false) {
      $("#confpasswordValidMsg").show();
      $(window).scrollTop($('#confpasswordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswordValidMsg").hide();
    }

    if (passwordConf != password) {
      $("#matchPwd").show();
      $(window).scrollTop($('#matchPwd').position().top);
      validateEditorTxt = 0;
    } else {
      $("#matchPwd").hide();
    }

    if (catofExpertiseArray.length <= 1) {
      $("#categoriesValidMsg").show();
      $(window).scrollTop($('#categoriesValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#categoriesValidMsg").hide();
    }

    if (categoriesArray.length <= 0) {
      $("#jobtypesValidMsg").show();
      $(window).scrollTop($('#jobtypesValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#jobtypesValidMsg").hide();
    }

    /*if ($('#authorize').val() == "") {
      $("#authorizaValidMsg").show();
      $(window).scrollTop($('#authorizaValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#authorizaValidMsg").hide();
    } */

    if (careerInformation == "") {
      $("#careerInfoValidMsg").show();
      $(window).scrollTop($('#careerInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#careerInfoValidMsg").hide();
    }

    /*
    if(additionalCoursesinfo == ""){
      $("#additional_coursesValidMsg").show();  
    $(window).scrollTop($('#additional_coursesValidMsg').position().top);
      validateEditorTxt = 0;     
    }else{
      $("#additional_coursesValidMsg").hide();  
    }
    */

    if (additionalThoughts == "") {
      $("#additionalThoughtsValidMsg").show();
      $(window).scrollTop($('#additionalThoughtsValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#additionalThoughtsValidMsg").hide();
    }

    if (skillSetinfo == "") {
      $("#skillSetinfoValidMsg").show();
      $(window).scrollTop($('#skillSetinfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#skillSetinfoValidMsg").hide();
    }

    if (fileExtension != "" && (fileExtension != "doc" && fileExtension != "docx" && fileExtension != "pdf")) {
      $("#fileError").show();
      $(window).scrollTop($('#fileError').position().top);
      validateEditorTxt = 0;
    } else {
      $("#fileError").hide();
    }

    /*
    console.log($('#pursuing_degree').val());
    if($('#pursuing_degree').val() == 3){
      if($('#school_district').val() == ''){
        $("#school_districtValidMsg").show();  
        $(window).scrollTop($('#school_districtValidMsg').position().top);
        validateEditorTxt = 0; 
      }
    }
    else{
      console.log('here');
      if($('#university_name').val() == ''){
        $("#university_nameValidMsg").show();  
        //$(window).scrollTop($('#university_nameValidMsg').position().top);
        validateEditorTxt = 0; 
      }
    }
    */

    if ($('#pursuing_degree').val() == '') {
      $("#pursuingValidMsg").show();
      $(window).scrollTop($('#pursuingValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#pursuingValidMsg").hide();
      if ($('#pursuing_degree').val() == 3) {
        if ($('#school_district').val() == '') {
          $("#school_districtValidMsg").show();
          $(window).scrollTop($('#school_districtValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#school_districtValidMsg").hide();
        }

        if ($('#school_district').val() == 0 && $('#schoolIdOther').val() == '') {
          $("#schoolIdOthermsg").show();
          $(window).scrollTop($('#schoolIdOthermsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#schoolIdOthermsg").hide();
        }

        var classyr = $('#class_year').val();
        var currentyearval = new Date().getFullYear();
        var selectedEduction = $('input[name="continueEducation"]:checked').val();
        //if (((classyr == currentyearval) || (classyr == (currentyearval + 1))) && selectedEduction == 'Y' && ($('#collegeId').val() == '')) {
        if (selectedEduction == 'Y' && ($('#collegeId').val() == '')) {
          $("#extensionvalidmsg").show();
          $(window).scrollTop($('#extensionvalidmsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#extensionvalidmsg").hide();
        }
      }
      else {
        console.log('here');
        if ($('#university_name').val() == '') {
          $("#university_nameValidMsg").show();
          $(window).scrollTop($('#university_nameValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#university_nameValidMsg").hide();
        }

        if ($('#university_name').val() == 22 && $('#collegeIdOther').val() == '') {
          $("#collegeIdOthermsg").show();
          $(window).scrollTop($('#collegeIdOthermsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#collegeIdOthermsg").hide();
        }
      }
    }

    if ($('#pursuing_degree').val() == '') {
      $('#pursuing_degreeValidMsg').show();
      $("#university_nameValidMsg").hide();
      $("#school_districtValidMsg").hide();
      var sdv = $('#pursuing_degreeValidMsg').position().top;
      sdv -= 100;
      $(window).scrollTop(sdv);
      validateEditorTxt = 0;
    }
    if (validateEditorTxt == 0) {
      return false;
    }


    var phone_val = $("#phone_number").val();
    var extclgid = $("#collegeId").val();
    const requestObject = {
      "siteId": 2,
      "countyId": 2,
      "firstName": $('#first_name').val(),
      "lastName": $('#last_name').val(),
      "email": $('#email_id').val(),
      "phone": phone_val,
      "schoolId": $("#school_district").val(),
      "classYear": $("#class_year").val(),
      "password": $('#password').val(),
      "categoriesOfExpertise": catofExpertiseArray,
      "isStudent": true,
      "reasonForSelectCareers": careerInformation,
      "experiance": skillSetinfo,
      //"course": additionalCoursesinfo,
      "course": "  ",

      "comments": additionalThoughts,
      // "studentInterestedIn": interestsArray,
      "studentInterestedIn": [3, 4],
      "seekingEmploymentTypes": categoriesArray,
      "authorization": $('#authorize').val(),
      "helpPrepare": "yes",
      "status": "1",
      "studentTalentConnectionForumIn": [1, 2],
      "educationId": $('#pursuing_degree').val(),
      "nameOfCollegeUniversity": $('#collegeIdOther').val(),
      "nameOfCollegeUniversityId": $('#university_name').val(),
      "schoolDistrictOther": $('#schoolIdOther').val(),
      "highSchoolDiplomaExtContinueEduStatus": selectedEduction,
      "highSchoolDiplomaExtNameOfInstitutionCollegeId": extclgid,
      "highSchoolDiplomaExtPursuingProgram": $('#pursuingProgram').val(),
    }

    if (fileName != "" && fileExtension != "") {
      requestObject.pdfByString = fileBase64;
      requestObject.fileName = fileName;
      requestObject.fileExtension = fileExtension;
    }


    console.log(requestObject);
    // return false;
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };
    services.adminCreateStudent(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#addstudentsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addstudentsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/studentlist');
        }, 1000);
      }
      else {
        $("#addstudentfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addstudentfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }

    });

  }

  function handleChangeAdditionalThoughtsDesc(content) {
    setAdditionalThoughts(content);
  }

  function handleChangeSkillInfoDesc(content) {
    setSkillsInfo(content);
  }


  function handleChangeCareerInfoDesc(content) {
    setCareerInfo(content);
  }
  //function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
  function handleImageUploadBefore(files, info, uploadHandler) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }
  const getEducation = () => {
    services.getEducation().then((res) => {
      console.log("getEducation data=" + JSON.stringify(res));
      var tempedu = res.data.content;
      //console.log(tempjobtypes);
      tempedu = tempedu.filter(function (elem) {
        return elem.name != 'PhD';
      });
      setEducation(tempedu);
    });
  }

  useEffect(() => {
    validateCheck();


    $("#university_nameValidMsg").hide();
    $(".se-dialog-tabs").hide();
    $("#school_districtValidMsg").hide();

    $("#university_name_degreeValidMsg").hide();
    $("#pursuing_degreeValidMsg").hide();
    $("#class_yearValidMsg").hide();
    //$("#phone_number").usPhoneFormat();
    ($('#phone_number')).usPhoneFormat();
    $("#fileError").hide();
    $('#matchPwd').hide();
    $("#careerInfoValidMsg").hide();
    $("#additionalThoughtsValidMsg").hide();
    $("#additional_coursesValidMsg").hide();
    $("#skillSetinfoValidMsg").hide();

    $("#firstNameValidMsg").hide();
    $("#lastNameValidMsg").hide();
    $("#emailValidMsg").hide();
    $("#phoneValidMsg").hide();
    $("#passwordValidMsg").hide();
    $("#matchPwd").hide();
    $("#confpasswordValidMsg").hide();
    $("#categoriesValidMsg").hide();
    $("#jobtypesValidMsg").hide();
    $("#authorizaValidMsg").hide();
    $("#emailReqMsg").hide();
    $("#passwordReqMsg").hide();
    $("#confpasswordReqMsg").hide();
    $("#addstudentsuccessMessage").hide();
    $('#addstudentfailMessage').hide();
    $('#school_districtValidMsg').hide();
    $('#university_nameValidMsg').hide();
    $("#pursuingValidMsg").hide();


    getyears();
    getSchoolistData();
    getEducation();
    getCollegeInfo();
    $('#college_div').hide();
    $("#schoolIdOtherDiv").hide();
    $('#collegeIdOtherDiv').hide();
    $('#schoolIdOthermsg').hide();
    $('#collegeIdOthermsg').hide();
    $('#planedu').hide();
    $('#extensionvalidmsg').hide();
    setTimeout(() => {
      $('#pursuing_degree').val('3');
      $('input[id="inlineRadio2"]').prop('checked', true);
    }, 1000)
    $('#continueEduDiv').hide();
    $("#inlineRadio1, #inlineRadio2").click(function () {
      var selectedEdu = $('input[name="continueEducation"]:checked').val();
      // alert(selectedEdu);
      if (selectedEdu == "Y") {
        $("#continueEduDiv").show();
      } else if (selectedEdu == "N") {
        $('#collegeId').val('');
        $('#pursuingProgram').val('');
        $("#continueEduDiv").hide();
      }
    });
    services.getIndustryData().then((res) => {

      console.log("Industry data=" + JSON.stringify(res.data));

      setCategory(res.data.content);

    });
    /*services.getJobType().then((res) => {
      console.log("setJobType data=" + JSON.stringify(res.data));

      var jobtype_unsort = res.data.content;
      var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
      array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));
      setJobType(jobtypes_sorted);
      //setJobType(res.data.content);
    }); */

    services.getJobType().then((res) => {
      //console.log("setJobType data=" + JSON.stringify(res.data));
      var jobtype_unsort = res.data.content;

      var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
      array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));
      
      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Continuing Education';
      });
      
      setJobType(jobtypes_sorted);
    });


  }, []);

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };

  $('#pursuing_degree').change(function () {
    //alert($('#pursuing_degree').val());
    $('#school_districtValidMsg').hide();
    $('#university_nameValidMsg').hide();
    $('#schoolIdOther').val('');
    $('#collegeIdOther').val('');
    $('#university_name').val('');
    $('#school_district').val('');
    $('#collegeIdOtherDiv').hide();
    $('#schoolIdOtherDiv').hide();
    if ($('#pursuing_degree').val() == 3) {
      $('#parent_authorization').show();
      $('#school_div').show();
      $('#college_div').hide();
      $('#school_district').prop('disabled', false);
      $('#university_name').prop('disabled', true);
      $('#class_year').change();
    }
    else {
      $('#parent_authorization').hide();
      $('#planedu').hide();
      $('#school_div').hide();
      $('#college_div').show();
      $('#school_district').prop('disabled', true);
      $('#university_name').prop('disabled', false);
    }
  })


  $('#class_year').change(function () {
    var classyr = $('#class_year').val();
    var currentyearval = new Date().getFullYear();

    //alert(currentyearval);
    //if (($('#pursuing_degree').val() == 3) && ((classyr == currentyearval) || (classyr == (currentyearval + 1)))) {
    if ($('#pursuing_degree').val() == 3) {
      $('#planedu').show();
    }
    else {
      $('#planedu').hide();
    }
  })

  function getImage() {
    var files = document.getElementById('resume').files;
    if (files.length > 0) {

      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];
      // alert(fileActName);
      setFileName(fileActName);
      setFileExtension(fextn);
      getBase64(files[0]);

      if (fextn != "doc" && fextn != "docx" && fextn != "pdf") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
      }

    }
  }

  function handleChangeSchool(event) {
    //alert("teste")
    //alert(event.target.value);
    var sch = event.target.value;
    $('#schoolIdOther').val('');
    $("#schoolIdOthermsg").hide();
    //console.log(event.target.value);
    //var sch = $("#schoolId'").val();    
    if (sch == "33") {
      $("#schoolIdOtherDiv").show();
    } else {
      $("#schoolIdOtherDiv").hide();
    }
  }

  function handleChangeCollege(event) {
    //alert("teste")
    //alert(event.target.value);
    var clg = event.target.value;
    $('#collegeIdOther').val('');
    //console.log(event.target.value);
    //var sch = $("#schoolId'").val();    
    if (clg == "22") {
      $("#collegeIdOtherDiv").show();
    } else {
      $("#collegeIdOtherDiv").hide();
    }
  }

  const getCollegeInfo = () => {
    services.getEnrolledCollege().then((res) => {
      //console.log("getEducation data=" + JSON.stringify(res.data));
      setCollegeInfo(res.data);
    });
  }

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var base64result = reader.result.split(',')[1];
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  const getyears = () => {
    var currentYear = new Date().getFullYear()
    var years = [];
    years.push(currentYear);
    for (var i = 1; i < 7; i++) {
      years.push(currentYear + i);
    }
    console.log("#41#41-->" + JSON.stringify(years));
    setCurrentYearList(years);
  }
  const getSchoolistData = () => {
    //alert("14");
    const requestObject = {
      "siteId": 2,
      "pageNumber": 1,
      "pageSize": 150
    }

    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getSchoolnDatapag(requestOptions).then((res) => {
      console.log("############36");
      console.log(JSON.stringify(res))
      if (res) {

        var contAr = res.content;
        //setProfileList(res.content);
        if (res) {
          setSchoolInData(res);
        }


      }
      //navigate('/thankyou');

    });


  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>Student Registration</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>

        {/* <h1>write your code here</h1> */}

        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">First Name </label>

                </div>
                <input id="first_name" name="first_name" type="text" className="form-control" placeholder="" />
                <div id="firstNameValidMsg" style={{ color: red }} className="error">First Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Last Name </label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" placeholder="" />
                <div id="lastNameValidMsg" style={{ color: red }} className="error">Last Name is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Personal Email</label>
                  <small className="mb-3">Please DO NOT use your school email.</small>
                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" placeholder="" />
                <div id="emailReqMsg" style={{ color: red }} className="error">Email Address is required.</div>
                <div id="emailValidMsg" style={{ color: red }} className="error">Invalid email address.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label"><span className="required">Phone</span> <small className="mx-2">xxx-xxx-xxxx </small></label>
                  <small className="mb-3">Use your parent's phone number if you do not have one.</small>
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" placeholder="" />
                <div id="phoneValidMsg" style={{ color: red }} className="error">Phone Number is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="password" name="password" className="form-control" placeholder="" />
                <div id="passwordReqMsg" style={{ color: red }} className="error">Password is required.</div>
                <div id="passwordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Confirm Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" class="form-control" id="passwordConf" />
                <div id="confpasswordReqMsg" style={{ color: red }} className="error">Confirm Password is required.</div>
                <div id="confpasswordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>

                <p id="matchPwd" style={{ color: red }} className="error">Passwords must match</p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">I am Currently Pursuing </label>
                </div>
                <select class="form-select" aria-label="Default select example" id="pursuing_degree" >
                  <option selected="" value=''>Select</option>
                  {
                    educations.map((data, index) => (
                      <option value={data.educationId}>{data.name}</option>
                    ))}
                </select>
                <div id="pursuing_degreeValidMsg" style={{ color: red }} className="error">This field is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Graduating Year</label>

                </div>
                <select className="form-select" aria-label="Select example" id="class_year" name="class_year">
                  <option selected value=''>Select Class Year</option>
                  {
                    currentYearList.map((data, index) => (

                      <option value={data}>{data}</option>


                    ))}
                </select>

                <div id="class_yearValidMsg" style={{ color: red }} className="error">Graduating Year is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="school_div">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">School District</label>

                </div>
                <select className="form-select" aria-label="Select example" id="school_district" name="school_district" onChange={handleChangeSchool}>
                  <option selected value=''>Select School</option>
                  {
                    schoolIds.map((data, index) => (
                      <option value={data.schoolId}>{data.name}</option>
                    ))
                  }
                 {/* <option value="0" >Other</option> */}
                </select>
                <div id="school_districtValidMsg" style={{ color: red }} className="error">School District is required.</div>
              </div>
            </div>

            <div class="col-md-6 " id="schoolIdOtherDiv">
              <div class="d-flex ">
                <label htmlFor="schoolIdOther" class="required form-label mr-2">Name of the Institution </label>
              </div>
              <input type="text" class="form-control " id="schoolIdOther" aria-describedby="emailHelp" placeholder="Other" />
              <div id="schoolIdOthermsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
            </div>

            <div className="col-lg-6" id="college_div">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">College / University  </label>
                </div>
                <select class="form-select" id="university_name" onChange={handleChangeCollege}>
                  <option value="">Select College</option>
                  {
                    collegeInfo.map((data, index) => (
                      <option value={data.enrolledCollegeId}>{data.name}</option>
                    ))}
                </select>
                <div id="university_nameValidMsg" style={{ color: red }} className="error">This field is required.</div>
              </div>
            </div>

            <div class="col-md-6 " id="collegeIdOtherDiv">
              <div class="d-flex ">
                <label htmlFor="collegeIdOther" class="required form-label mr-2">Name of the Institution </label>
              </div>
              <input type="text" class="form-control " id="collegeIdOther" aria-describedby="emailHelp" placeholder="Other" />
              <div id="collegeIdOthermsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
            </div>

            <div class="col-lg-12 mb-4" id="planedu">

              <div class="d-flex">
                <label htmlFor="education" class="required form-label mr-2">Are you planning to go to college after high school? </label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="continueEducation" id="inlineRadio1" value="Y" style={{ borderRadius: "30px" }} />
                <label class="form-check-label" htmlFor="inlineRadio1">YES</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="continueEducation" id="inlineRadio2" value="N" />
                <label class="form-check-label" htmlFor="inlineRadio2">NO</label>
              </div>

              <div className="row" id="continueEduDiv">
                <div className="col-md-6 mt-4">
                  <div class="d-flex"><label htmlFor="lookingFor" class="required form-label mr-2">Name of The Institution </label></div>
                  <select class="form-select" id="collegeId">
                    <option value="">Select College</option>
                    <option value="0">I Don't know yet</option>
                    {
                      collegeInfo.map((data, index) => (
                        <option value={data.enrolledCollegeId}>{data.name}</option>
                      ))}
                  </select>
                  <div id="extensionvalidmsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
                </div>

                <div className="col-md-6 mt-4">
                  <div class="d-flex"><label htmlFor="pursuingProgram" class="form-label mr-2">Pursuing Program</label></div>
                  <input type="text" class="form-control " id="pursuingProgram" aria-describedby="emailHelp" placeholder="Program Name" />
                </div>
              </div>

            </div>


            <div className="col-lg-12 mb-10">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Fields I am Interested in</label>

                </div>
                <small>(Select up to three)</small>
                <div class="row">
                  {

                    categories.map((data, index) => (


                      <div className="col-md-6 form-check form-check-custom form-check-solid mb-4"><input class="form-check-input category_mcls" type="checkbox" name="category_m" value={data.catId} />  <label class="form-check-label" htmlFor="defaultCheck1"> {data.name} </label></div>

                    ))}
                </div>
              </div>
              <div id="categoriesValidMsg" style={{ color: red }} className="error">Please Check at least 1 category.</div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label"> I am interested in these fields for these reasons</label>
                </div>
                <small>(Leave blank if not known.)</small>
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="careerInfo"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setCareerInfo(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "120",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                     /** ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' ], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'], */

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeCareerInfoDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />

                <div id="careerInfoValidMsg" style={{ color: red }} className="error my-2">This field is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">I have the following relevant Skills /Experience.</label>
                </div>
                <small>(Leave blank if not known.)</small>
                {/*<textarea name="skills" id="skills" cols="30" rows="10"  style={{maxHeight: 75, minWidth: '100%'}}></textarea> */}

                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="skills"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setSkillsInfo(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "120",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      /**['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' ], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'], */

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSkillInfoDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="skillSetinfoValidMsg" style={{ color: red }} className="error">List of Skills is required.</div>
              </div>

            </div>
            {/* <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">What additional courses might help you prepare for this career?</label>
                                </div>
                              
                               <CKEditor
                            editor={ ClassicEditor }
                            id="additional_courses"                            
                            onReady={ editor => {
                                
                                console.log( 'Editor is ready to use!', editor );
                               
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setAdditionalCourses(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        />
                        <div id="additional_coursesValidMsg" style={{color:red}} className="error">Additional Courses is required.</div>
                            </div>
                            

                        </div> */}
<div className="col-lg-12 mb-10">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">I am submitting this form because I am looking for</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <ul className="row mb-4">
                      {
                        jobTypes.map((data, index) => (


                          <li className="col-md-6 form-check form-check-custom form-check-solid mb-4"><input class="form-check-input" type="checkbox" name="seeking" value={data.jobTypeId} id={data.jobTypeId} />  <label class="form-check-label" htmlFor="defaultCheck1"> {data.name} </label></li>

                        ))}
                    </ul>

                  </div>
                </div>
                <div id="jobtypesValidMsg" style={{ color: red }} className="error">Please check at least 1 option.</div>

              </div>
            </div>

            <div className="col-lg-12 mb-10">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">My Resume (Optional)</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <input class="form-control form-control-lg browse mr-2 w-100" id="resume" type="file" onChange={() => getImage()} />
                    <small> 1MB Max, File Type: PDF, DOC, DOCX</small>

                  </div>
                  <div id="fileError" style={{ color: red }} className="error">Invalid file format</div>
                </div>


              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Any additional Thoughts/comments that might be helpful?</label>
                </div>
                <small>(Leave blank if not known.)</small>
                {/*  <textarea name="additional_thoughts" id="additional_thoughts" cols="30" rows="10"  style={{maxHeight: 75, minWidth: '100%'}}></textarea> */}
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="additionalThoughts"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setAdditionalThoughts(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "120",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                     /** ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' ], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'], */

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeAdditionalThoughtsDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="additionalThoughtsValidMsg" style={{ color: red }} className="error">Additional Thoughts is required.</div>
              </div>

            </div>

            {/*

                        <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label className=" form-label">What courses have taken that are related to this career?</label>
                                  <small className="mb-3">Max 500 Characters</small>
                 </div>
                 
                 <CKEditor
                            editor={ ClassicEditor }
                            id="coursesInfo"                            
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setCoursesInfo(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        />
                 
              </div>
                 </div>
                 

                       */}

            <div className="col-lg-6 mb-10"></div>

            

            <div className="col-lg-12 mb-10" id="parent_authorization">
              <div className='mb-10'>
                <div className="d-flex flex-column ">
                  <label className=" form-label">My Parent/guardian authorizes my information to be shared (if under 18):</label>
                </div>
              </div>
              <select className="form-select" aria-label="Select example" id="authorize" >
                <option selected value="">Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <div id="authorizaValidMsg" style={{ color: red }} className="error">Please select at least 1 option.</div>
            </div>

            <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "135px" }}> Register </button>

          </div>

          <div id="addstudentsuccessMessage" class="alert alert-success" role="alert">Student Registered Successfully</div>
          <div id="addstudentfailMessage" class="alert alert-danger" role="alert">Please try again</div>
        </div>

      </form>


    </>
  )
}
export { CreateStudent }